const variants = {
  white: 'white',
  darkBlue: 'darkBlue',
  coral: 'coral',
  callToAction: 'callToAction',
  error: 'error',
  gray: 'gray',
  black: 'black',
};

export default variants;
